import React from "react";
import {
  SEO,
  PageLayout,
  ContactForm,
  createDefaultMessageFromState,
} from "@bluefin/components";
import { Grid, Header, List } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class HiringPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout className={"hiring-page"} hero={null}>
          <Grid stackable={true} columns={1} textAlign={"left"} centered={true}>
            <Grid.Column width={8}>
              <Header as={"h1"}>Join our Team</Header>
              <Header textAlign={"left"} as={"h3"}>
                If you're interested in one of our open positions, start by
                applying here. In the Message Box, state the position you are
                applying for.
              </Header>
              <List
                items={[
                  "Busser/Food Runner",
                  "Host",
                  "Server",
                  "Bartender",
                  "Dishwasher",
                  "Line/Prep Cook",
                  "Cleaning Crew",
                ]}
              />
              <Header textAlign={"left"} as={"h3"}>
                Apply Now !
              </Header>
              <ContactForm
                constructMessage={createDefaultMessageFromState}
                fields={[
                  {
                    label: "name",
                    placeholder: "Full Name",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "email",
                    placeholder: "Email",
                    type: "input",
                    inputType: "email",
                    required: true,
                  },
                  {
                    label: "phone",
                    placeholder: "Phone Number",
                    type: "input",
                    required: true,
                  },
                  {
                    label: "Positions",
                    placeholder: "Position",
                    type: "multiSelect",
                    required: true,
                    options: [
                      {
                        label: "Busser/Food Runner",
                        value: "Busser/Food Runner",
                      },
                      { label: "Host", value: "Host" },
                      { label: "Server", value: "Server" },
                      { label: "Bartender", value: "Bartender" },
                      { label: "Dishwasher", value: "Dishwasher" },
                      { label: "Cleaning Crew", value: "Cleaning Crew" },
                      { label: "Line/Prep Cook", value: "Line/Prep Cook" },
                    ],
                  },
                  {
                    displayLabel:
                      "What are your availability? Include days of the week and preferred working hours for each day",
                    label: "availability",
                    placeholder:
                      "What are your availability? Include days of the week and preferred working hours for each day",
                    type: "textarea",
                    required: false,
                  },
                  {
                    displayLabel:
                      "How many hours per week are you seeking, Are you interested in full-time or part-time work?",
                    label: "hours",
                    placeholder:
                      "How many hours per week are you seeking, Are you interested in full-time or part-time work?",
                    type: "textarea",
                    required: false,
                  },
                  {
                    displayLabel: "Work Experience",
                    label: "workExperience",
                    placeholder: "Work Experience",
                    type: "textarea",
                    required: false,
                  },
                  {
                    displayLabel: "Additional Message",
                    label: "additionalMessage",
                    placeholder: "Additional Message",
                    type: "textarea",
                    required: false,
                  },
                ]}
                buttonText={"Send"}
                centeredHeaders={true}
                className={""}
                fluidButton={true}
                header={""}
                inline={false}
                showLabels={true}
                subheader={""}
                termsCopy={""}
                withContainer={true}
                locationId={fishermanBusiness.primaryLocation._id}
                businessId={fishermanBusiness._id}
                businessType={fishermanBusiness.type}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        _id
      }
      _id
      type
    }
    fishermanBusinessWebsitePage(title: { eq: "Hiring" }) {
      title
      components {
        fastId
        componentIdentifier
        order
        files {
          file
        }
      }
    }
  }
`;
